import { isMobile } from './deviceUtils';

/**
 * W&H質問フォームのEnterキー処理を行う共通関数
 * PC環境ではEnterで送信、Shift+Enterで改行
 * モバイル環境ではEnterで改行
 *
 * @param event KeyboardEvent - Enterキーイベント
 * @param submit () => void - 送信処理を実行する関数
 */
export function handleWandhEnterKey(event: KeyboardEvent, submit: () => void): void {
  // IME（日本語入力）による変換中の場合は何もしない
  if (event.isComposing) {
    return;
  }

  // モバイル環境の場合は改行を許可するため、送信処理を行わない
  if (isMobile()) {
    event.stopPropagation();
    return;
  }

  // PC環境でShift+Enterが押された場合は改行を許可
  if (event.shiftKey) {
    event.stopPropagation();
    return;
  }

  // PC環境で単独のEnterキーが押された場合は送信処理を実行
  // デフォルトの改行動作を防止してから送信関数を呼び出す
  event.preventDefault();
  submit();
}

/**
 * キーワード検索フォームのEnterキー処理を行う共通関数
 * PC/モバイル共通でEnterで送信
 *
 * @param event KeyboardEvent - Enterキーイベント
 * @param submit () => void - 検索処理を実行する関数
 */
export function handleKeywordEnterKey(event: KeyboardEvent, submit: () => void): void {
  // IME（日本語入力）による変換中の場合は何もしない
  if (event.isComposing) {
    return;
  }

  // デフォルトのEnterキー動作（フォーム送信）を防止
  event.preventDefault();

  // PC・モバイル環境問わず、Enterキーで即座に検索を開始
  submit();
}
